import { jsx as _jsx } from "react/jsx-runtime";
export default function ChevronLeftIcon(props) {
    return (_jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...props, children: _jsx("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z", fill: "currentColor" }) }));
}
